import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getNoticias, getBoletins } from "../services/cmsServices";

const API_BASE = process.env.REACT_APP_API_CMS;

const SecaoNoticias = () => {
  const [abaAtiva, setAbaAtiva] = useState("boletim");
  const [noticias, setNoticias] = useState([]);
  const [boletins, setBoletins] = useState([]);
  const [noticiaSelecionada, setNoticiaSelecionada] = useState(null);

  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    async function fetchData() {
      const noticiasData = await getNoticias();
      const boletinsData = await getBoletins();
      setNoticias(noticiasData.items || []); // Acessa a propriedade items
      setBoletins(boletinsData.items || []); // Acessa a propriedade items
    }
    fetchData();
  }, []);

  useEffect(() => {
    if (location.pathname.includes("/boletim/")) {
      setAbaAtiva("boletim");
    } else if (location.pathname.includes("/noticia/")) {
      setAbaAtiva("noticias");
    }
  }, [location]);

  const filtradas = abaAtiva === "noticias" ? noticias : boletins;

  const resumoTexto = (texto, max = 60) => {
    if (!texto) return ""; // Adiciona verificação para texto vazio
    return texto.length > max ? texto.slice(0, max).trim() + "..." : texto;
  };

  const handleClick = (item) => {
    const rota = abaAtiva === "noticias" ? "noticia" : "boletim";
    navigate(`/${rota}/${item.slug}`);
  };

  return (
    <section className="bg-white py-4 max-w-7xl mx-auto rounded-xl">
      {/* Abas */}
      <div className="flex gap-2 justify-center mb-6">
        <button
          className={`px-4 py-2 rounded-md text-sm font-semibold transition ${abaAtiva === "boletim"
            ? "bg-yellow-400 text-black"
            : "bg-gray-100 text-black hover:bg-gray-200"
            }`}
          onClick={() => {
            setAbaAtiva("boletim");
            setNoticiaSelecionada(null);
          }}
        >
          Boletim Diário
        </button>
        <button
          className={`px-4 py-2 rounded-md text-sm font-semibold transition ${abaAtiva === "noticias"
            ? "bg-yellow-400 text-black"
            : "bg-gray-100 text-black hover:bg-gray-200"
            }`}
          onClick={() => {
            setAbaAtiva("noticias");
            setNoticiaSelecionada(null);
          }}
        >
          Notícias
        </button>
      </div>

      {/* Título */}
      <div className="text-center">
        <h2 className="text-lg font-bold mb-5 relative inline-block after:block after:w-100 after:h-[3px] after:bg-yellow-400 after:mt-2 after:mx-auto">
          Notícias e Boletim Diário
        </h2>
      </div>

      {/* Detalhe selecionado */}
      {noticiaSelecionada && (
        <div className="mb-8 bg-yellow-50 border-l-4 border-yellow-400 shadow">
          <div className="flex justify-between items-start mb-2">
            <h3 className="text-sm font-bold text-black">
              {noticiaSelecionada.data_publicacao} - {noticiaSelecionada.titulo}
            </h3>
            <button
              onClick={() => setNoticiaSelecionada(null)}
              className="text-sm text-red-600 font-semibold hover:underline"
            >
              Fechar ✕
            </button>
          </div>
          <p className="text-sm text-gray-800">{noticiaSelecionada.resumo}</p>
        </div>
      )}

      {/* Lista */}
      <div className="max-h-[800px] overflow-y-auto space-y-4 p-2">
        {filtradas.map((n) => {
          const isAtiva =
            location.pathname.includes(n.slug) &&
            ((abaAtiva === "noticias" && location.pathname.includes("/noticia/")) ||
              (abaAtiva === "boletim" && location.pathname.includes("/boletim/")));

          return (
            <div
              key={n.id}
              className={`flex flex-col sm:flex-row rounded overflow-hidden cursor-pointer transition-all ${isAtiva
                ? "bg-yellow-100 border border-yellow-400 shadow-md"
                : "bg-gray-50 hover:shadow"
                }`}
              onClick={() => handleClick(n)}
            >
              {n.imagem && (
                <img
                  src={n.imagem} // Remove API_BASE pois a URL já está completa
                  alt={n.titulo}
                  className="object-cover w-full sm:w-[130px] sm:h-[100px]"
                />
              )}
              <div className="p-4">
                <h3 className="text-base sm:text-[12px] lg:text-sm font-bold text-gray-900 mb-1">
                  {new Date(n.data_publicacao + "T00:00:00-03:00").toLocaleDateString("pt-BR", {
                    timeZone: "America/Sao_Paulo"
                  })} - {n.titulo}
                </h3>
                <p className="text-sm sm:text-[12px] lg:text-sm text-gray-800 line-clamp-4">
                  {resumoTexto(n.resumo)}
                </p>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default SecaoNoticias;